import { configureStore } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import apiKeysReducer from "./slices/apiKeysSlice";
import onboardingReducer from "./slices/onboardingSlice";

// Create and configure the Redux store
const store = configureStore({
  reducer: {
    apiKeys: apiKeysReducer,
    onboarding: onboardingReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Custom hook for using the dispatch function with TypeScript support
export const useAppDispatch = () => useDispatch<AppDispatch>();

export default store;
